import '../css/styles.css';
import '../css/cuppa.css';
import '../css/fonts/fontawesome.css';
import {GetStorage} from "../../cuppa/reactComponents/GetStorage";
import {useEffect, useState} from "react";
import {Storages} from "../controllers/Storages";
import {Login} from "./auth/Login";
import {App} from "./App";
import {CuppaPortal} from "../../cuppa/reactComponents/CuppaPortal";
import {Globals} from "../controllers/Globals";
import {Language} from "../controllers/Language";
import {cuppa, log, val} from "../../cuppa/cuppa";
import {AppLogout} from "./AppLogout";

export function Main(){
	const [user, setUser] = useState();

	useEffect(()=>{
		Language.retrieveStoredLanguage().then();
	}, []);

	let pathData = cuppa.getPathData();
	return (
		<div>
			<GetStorage {...Storages.user} callback={setUser} />
			{!user || val(pathData, `baseArray.0`) === "reset-password" ? <AppLogout /> : <App />}
			<CuppaPortal ref={ ref =>{ if(!ref) return; Globals.mainPortal = ref } } />
		</div>
	)
}


